module.exports = __webpack_public_path__ + "static/media/matias.ae3e34be.png";